export class NetworkError<T> extends Error {
  statusCode: number;
  body?: T;

  constructor(message: string, statusCode: number, body?: T) {
    super(message);
    this.statusCode = statusCode;
    this.body = body;
  }
}
